// extracted by mini-css-extract-plugin
export default {"wrapper":"CustomSwitcher_wrapper__c7-Gw"};